import { canProductInquiry } from './canProductInquiry';
export const canDisplayProductPrice = (product: GQL.IProduct) => {
  return product.display === true && !canProductInquiry(product);
};


// WEBPACK FOOTER //
// ./src/helpers/products/canDisplayProductPrice.ts